<template>
  <div>
    <v-fab-transition>
      <v-btn
        v-if="!isEdit"
        class="ml-3 mb-3"
        color="primary"
        width="27"
        height="27"
        fab
        dark
        small
        absolute
        :bottom="bottom"
        :right="align === 'right'"
        :left="align === 'left'"
        @click="edit"
        :loading="loading"
      >
        <div class="d-flex flex-column">
          <v-icon size="15" style="height: 10px">mdi-pencil-outline</v-icon>
          <v-icon size="20" style="height: 5px">mdi-minus</v-icon>
        </div>
      </v-btn>

      <v-btn
        v-else
        class="ml-3 mb-3"
        color="success"
        width="27"
        height="27"
        fab
        dark
        small
        absolute
        :bottom="bottom"
        :right="align === 'right'"
        :left="align === 'left'"
        @click="save"
        :loading="loading"
      >
        <div class="d-flex flex-column">
          <v-icon size="15" style="height: 10px">mdi-check</v-icon>
          <v-icon size="20" style="height: 5px">mdi-minus</v-icon>
        </div>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
export default {
  props: {
    isEdit: {
      type: Boolean,
    },
    bottom: {
      type: Boolean,
    },
    align: {
      type: String,
    },
    loading: Boolean,
  },
  methods: {
    edit() {
      this.$emit("edit");
    },
    save() {
      this.$emit("save");
    },
  },
};
</script>
